// extracted by mini-css-extract-plugin
export default {"cursor":"cursor_cursor__wQPMW"};